export default {
      id: "inductions-icon-usage",
      viewBox: "0 0 28 29",
      url: __webpack_public_path__ + "sprite.svg#inductions-icon",
      toString: function () {
        return this.url;
      }
    }